import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Info from "@insite/mobius/Icons/Info";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Tooltip from "@MasterBluePrint/MobiusOverrides/Tooltip/Tooltip";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    leadtimelabel = "leadtimelabel",
    leadtimeTollTip = "leadtimeTollTip",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.leadtimelabel]: string;
        [fields.leadtimeTollTip]: string;
    };
}
type Props = OwnProps & HasProduct;

export interface ProductDetailsAverageLeadTimeStyle {
    leadTimeContainer?: InjectableCss;
    leadTimeLabel?: InjectableCss;
    leadTimeValue?: InjectableCss;
    tooltipStyles?: InjectableCss;
    requestTime?: InjectableCss;
}

export const averageLeadTimeStyles: ProductDetailsAverageLeadTimeStyle = {
    leadTimeContainer: {
        css: css`
            font-weight: 600;
            font-size: .9rem !important;
            margin-bottom: .6rem;
            font-family: 'Lato', sans-serif;
            display:flex;
            color: ${themeColors.colorCharcoalGrey};
        `,
    },
    leadTimeLabel: {
        css: css`
            margin-right: .5rem;    
            display:flex;
            font-size: .9rem !important;
        `,
    },
    leadTimeValue: {
        css: css`
            color: #333F48;
            font-family: 'Lato', sans-serif;
            font-weight:400;
            display:flex;
            font-size: .9rem !important;
            span {
                margin-left:1rem;
            }
        `,
    },
    tooltipStyles: {
        css: css`
        padding:.3rem .5rem;
        width: auto;
        color:#fff;
        margin: 0 0 1rem;
    `,
    },
    requestTime: {
        css: css`
        > span {
        font-size: .9rem;
        color:#333F48 !important;
        text-decoration: underline;
        &:hover {
            color:#2060AD !important;
        }
    }
        `,
    },
};

const styles = averageLeadTimeStyles;

const ProductDetailsAverageLeadTime: React.FC<Props> = ({ fields, product, productInfo }) => {
  
  
    const { inventory, unitOfMeasure, failedToLoadInventory } = productInfo;
    const availability =
        inventory?.inventoryAvailabilityDtos?.find(
            o => o.unitOfMeasure.toLowerCase() === (unitOfMeasure?.toLowerCase() || ""),
        )?.availability || undefined;
    const manufacturerItemData = product?.manufacturerItem || "";
    if (!availability || !product) {
        return null;
    }
    if (product?.properties?.averageLeadTime &&
        product?.properties?.averageLeadTime !== null &&
        product?.properties?.averageLeadTime !== ""  &&
        product?.properties?.averageLeadTime !== "0" && 
        product?.properties?.isDirectShipFromManufacturer?.toLowerCase() === 'false') {
        return (
            <>
                {availability.message !== "Request Lead Time" && product?.properties?.isDiscontinued === "true" ? (
                    
                    <Typography as="div" className="request-link mb-10">                       
                        <Link href={`/Request-Lead-Time?mfpn=${manufacturerItemData}`} {...styles.requestTime}>
                            <Typography>{translate("Out of Stock")}</Typography>
                        </Link>
                    </Typography>
                ) : (
                        <StyledWrapper {...styles.leadTimeContainer} className="mfg-leadtime-details">
                            <Typography {...styles.leadTimeLabel}>
                                {fields.leadtimelabel || translate("Manufacturer Lead Time :")}
                            </Typography>
                            <Typography {...styles.leadTimeValue}>
                                {product.properties.averageLeadTime} {translate("Days")}
                                {fields.leadtimeTollTip !== "" && (
                                    <Tooltip learnMoreUrl="" iconProps={{ src: Info }} {...styles.tooltipStyles} text={fields.leadtimeTollTip}></Tooltip>
                                )}
                            </Typography>
                        </StyledWrapper>
                    )
                }
            </>
        );
    }
    return <></>;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsAverageLeadTime),
    definition: {
        displayName: "Average Lead Time Property",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.leadtimelabel,
                editorTemplate: "TextField",
                defaultValue: "Manufacturer Lead Time :",
                fieldType: "General",
            },
            {
                name: fields.leadtimeTollTip,
                editorTemplate: "TextField",
                defaultValue: "Manufacturer Lead Time Tool Tip Message :",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
